// AUTO-GENERATED by app-config-utils/generateFontsFile — do not edit by hand.
// Regenerated on each build/dev from the store's settings.layout.fonts.
import { Roboto_Condensed, Roboto, Grape_Nuts } from 'next/font/google'

const robotoCondensed = Roboto_Condensed({
  subsets: ['latin', 'latin-ext'],
  weight: ['400', '700']
})

const roboto = Roboto({
  subsets: ['latin', 'latin-ext'],
  weight: ['400', '500', '700', '900']
})

const grapeNuts = Grape_Nuts({
  subsets: ['latin', 'latin-ext'],
  weight: ['400']
})

export const fonts = {
  heading: robotoCondensed.style.fontFamily,
  body: roboto.style.fontFamily,
  slogan: grapeNuts.style.fontFamily
}
